import { render } from "./CustomerAddress.vue?vue&type=template&id=e894a62e&scoped=true"
import script from "./CustomerAddress.vue?vue&type=script&lang=js"
export * from "./CustomerAddress.vue?vue&type=script&lang=js"

import "./CustomerAddress.vue?vue&type=style&index=0&id=e894a62e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e894a62e"]])

export default __exports__